export const removeOne = (haystack, needle) => {
  let position = -1;
  if (typeof needle === 'string') {
    position = haystack.indexOf(needle);
  } else {
    const {
      label
    } = needle;
    for (let i = 0; i < haystack.length; i += 1) {
      if (haystack[i].label === label) {
        position = i;
        break;
      }
    }
  }
  if (position !== -1) {
    const temp = [...haystack];
    temp.splice(position, 1);
    return temp;
  }
  return haystack;
};
export const appendOne = (haystack, needle) => haystack.concat(needle);
export const matches = (haystack, needle) => {
  const match = haystack.filter(item => item.label === needle.label)[0];
  if (match && needle.status) {
    return match.status === needle.status;
  }
  return !!match;
};